var dataAccessor = (function () {
  if (typeof window !== 'undefined' && !window.DefaultAICharacter) {
    window.DefaultAICharacter =
      (window.fixtures && window.fixtures.currentAI) || {
        name: 'Isekai narrator',
        description:
          'An omniscient narrator for epic isekai roleplay adventures.',
        greeting:
          'Welcome to a world beyond your imagination. What path will you choose?',
        avatar_file_name: '',
      };
  }
  var dataAccessorSelf = {};
  if (typeof window !== 'undefined') {
    window.fixtures = window.fixtures || {};
  }
  var baseProxyUrl = '';

  dataAccessorSelf.deleteUser = function (user, callback) {
    var baseUrl = '';
    fetch(baseUrl + '/api/delete-account', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        uid: user.uid,
      }),
    })
      .then(function (response) {
        if (response.status === 200) {
          return response.json();
        }
      })
      .then(function (data) {
        if (window.logout) {
          window.logout();
          return;
        }

        // Soft logout fallback: no navigation
        (async function () {
          try {
            await fetch('/api/logout', {
              method: 'POST',
              credentials: 'include',
            });
          } catch (e) {
            console.error('[dataAccessor] Logout API error:', e);
          }

          try {
            window.userData = {};
            window.currentUser = null;
            window.userSecret = null;

            if (typeof localStorage !== 'undefined') {
              localStorage.removeItem('userData');
              localStorage.removeItem('userSecret');
              localStorage.removeItem('userIsSubscribed');
              localStorage.removeItem('userDataTimestamp');
              localStorage.removeItem('netwrck_user');
            }
            if (typeof sessionStorage !== 'undefined') {
              sessionStorage.clear();
            }

            function deleteCookie(name) {
              document.cookie =
                name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
            }
            [
              'userData',
              'userSecret',
              'user_secret',
              'userIsSubscribed',
              'userDataTimestamp',
            ].forEach(deleteCookie);

            var loginEls = document.querySelectorAll(
              '.header-login-signup, .login-link, .signup-link'
            );
            var logoutEls = document.querySelectorAll('.header-login-signout');
            var accountEls = document.querySelectorAll(
              '.header-account, .account-link'
            );
            var subscribeEls = document.querySelectorAll('.header-subscribe');

            loginEls.forEach(function (el) {
              el.style.display = '';
            });
            logoutEls.forEach(function (el) {
              el.style.display = 'none';
            });
            accountEls.forEach(function (el) {
              el.style.display = 'none';
            });
            subscribeEls.forEach(function (el) {
              el.style.display = 'none';
            });

            if (window.dispatchEvent) {
              try {
                window.dispatchEvent(new Event('authStateChanged'));
              } catch { /* Error ignored */ }
            }
          } catch (err) {
            console.warn('[dataAccessor] Soft logout UI update failed:', err);
          }
        })();
      })
      .catch(function (error) {
        console.log(error);
        alert('Error deleting user, please contact lee.penkman@netwrck.com');
      });
  };

  dataAccessorSelf.allRooms = [];
  var roomsCombinedCache = null;
  var roomsCombinedPending = {};
  var roomsCombinedCacheTTL = 60000;

  function roomsCacheKey() {
    var user = typeof window !== 'undefined' && window.userData ? window.userData : {};
    return String(
      user.id ||
        user.email ||
        (user.secret || user.api_key || window.userSecret ? 'authenticated' : 'guest')
    );
  }

  function hasRoomsUser() {
    var user = typeof window !== 'undefined' && window.userData ? window.userData : {};
    return Boolean(user.id || user.email || user.secret || user.api_key || window.userSecret);
  }

  dataAccessorSelf.invalidateRoomsCache = function () {
    roomsCombinedCache = null;
    dataAccessorSelf.allRooms = [];
  };

  dataAccessorSelf.getAllRooms = function (callback) {
    dataAccessorSelf.getRoomsCombined(function (res) {
      var combined = [];
      if (res && Array.isArray(res.myRooms)) combined = combined.concat(res.myRooms);
      if (res && Array.isArray(res.allRooms)) combined = combined.concat(res.allRooms);
      dataAccessorSelf.allRooms = combined;
      callback(combined);
    });
  };

  dataAccessorSelf.getRoomsCombined = function (callback) {
    var key = roomsCacheKey();
    var now = Date.now();
    if (
      roomsCombinedCache &&
      roomsCombinedCache.key === key &&
      now - roomsCombinedCache.created < roomsCombinedCacheTTL
    ) {
      callback(roomsCombinedCache.value);
      return;
    }
    if (roomsCombinedPending[key]) {
      roomsCombinedPending[key].push(callback);
      return;
    }
    roomsCombinedPending[key] = [callback];
    var myRooms = [];
    var allRooms = [];
    var done = 0;
    function finish() {
      var myKeys = new Set();
      var ownedRooms = [];
      for (var i = 0; i < myRooms.length && ownedRooms.length < 12; i++) {
        if (!myRooms[i]) continue;
        var owned = Object.assign({}, myRooms[i], { is_owned: true });
        var ownedKey = owned.room_key || owned.id || owned.name;
        if (ownedKey) myKeys.add(String(ownedKey));
        ownedRooms.push(owned);
      }
      var dedupAll = [];
      for (var j = 0; j < allRooms.length && dedupAll.length < 60; j++) {
        var r = allRooms[j] || {};
        var roomKey = r.room_key || r.id || r.name;
        if (!roomKey || !myKeys.has(String(roomKey))) dedupAll.push(r);
      }
      var value = { myRooms: ownedRooms, allRooms: dedupAll };
      roomsCombinedCache = { key: key, created: Date.now(), value: value };
      var callbacks = roomsCombinedPending[key] || [];
      delete roomsCombinedPending[key];
      for (var k = 0; k < callbacks.length; k++) callbacks[k](value);
    }

    if (hasRoomsUser()) {
      $.ajax({
        url: '/api/get-all-rooms',
        type: 'GET',
        success: function (data) {
          var roomsRaw = data && data.rooms ? data.rooms : data && data.data ? data.data : [];
          myRooms = Array.isArray(roomsRaw) ? roomsRaw : [];
          done++;
          if (done === 2) finish();
        },
        error: function () {
          done++;
          if (done === 2) finish();
        },
      });
    } else {
      done++;
    }

    $.ajax({
      url: '/api/get-all-rooms?popular=true&query=' + encodeURIComponent('%'),
      type: 'GET',
      success: function (data) {
        var roomsRaw = data && data.rooms ? data.rooms : data && data.data ? data.data : [];
        allRooms = Array.isArray(roomsRaw) ? roomsRaw : [];
        done++;
        if (done === 2) finish();
      },
      error: function () {
        done++;
        if (done === 2) finish();
      },
    });
  };

  dataAccessorSelf.searchRooms = function (query, callback) {
    if (!query || typeof query !== 'string') {
      callback([]);
      return;
    }
    $.ajax({
      url: '/api/get-all-rooms?query=' + encodeURIComponent(query),
      type: 'GET',
      success: function (data) {
        var roomsRaw =
          data && data.data
            ? data.data
            : data && data.rooms
              ? data.rooms
              : data;
        var rooms = Array.isArray(roomsRaw) ? roomsRaw : [];
        callback(rooms);
      },
      error: function (data) {
        console.log(data);
        callback([]);
      },
    });
  };
  // Safely read search_base_url; avoid ReferenceError before fixtures exist
  var searchBaseUrl = '';
  try {
    if (
      typeof window !== 'undefined' &&
      window.fixtures &&
      window.fixtures['search_base_url']
    ) {
      searchBaseUrl = window.fixtures['search_base_url'];
    }
  } catch (e) {
    console.error('Error reading search_base_url from fixtures:', e);
    searchBaseUrl = '';
  }

  if (searchBaseUrl && searchBaseUrl.indexOf('localhost') > -1) {
    searchBaseUrl = '';
  }

  dataAccessorSelf.searchAis = function (query) {
    console.log('Searching for AIs with query:', query);

    var params = new URLSearchParams({ query: query });
    if (window.addAllowNSFWParam) {
      window.addAllowNSFWParam(params);
    }
    var url = searchBaseUrl + '/api/search-ais?' + params.toString();
    var fallbackParams = new URLSearchParams({ query: query });
    if (window.addAllowNSFWParam) {
      window.addAllowNSFWParam(fallbackParams);
    }

    function normalizeResults(data) {
      if (!data) {
        return [];
      }
      if (Array.isArray(data)) {
        return data;
      }
      if (Array.isArray(data.results)) {
        return data.results;
      }
      if (Array.isArray(data.data)) {
        return data.data;
      }
      return [];
    }

    function localFilter() {
      if (
        dataAccessorSelf.initialAIs &&
        dataAccessorSelf.initialAIs.length > 0
      ) {
        console.log('Using client-side filtering as fallback');
        var searchQuery = query.toLowerCase().trim();
        return dataAccessorSelf.initialAIs.filter(
          (ai) =>
            (ai.name && ai.name.toLowerCase().includes(searchQuery)) ||
            (ai.description &&
              ai.description.toLowerCase().includes(searchQuery)) ||
            (ai.greeting &&
              ai.greeting.toLowerCase().includes(searchQuery)) ||
            (ai.tags &&
              ((Array.isArray(ai.tags) &&
                ai.tags.some((tag) =>
                  String(tag).toLowerCase().includes(searchQuery)
                )) ||
                (typeof ai.tags === 'string' &&
                  ai.tags.toLowerCase().includes(searchQuery))))
        );
      }
      return [];
    }

    function fetchFallback() {
      return fetch('/api/get_bots_by_query?' + fallbackParams.toString())
        .then((res) => {
          if (!res.ok) {
            throw new Error('Both search endpoints failed');
          }
          return res.json();
        })
        .then(function (data) {
          return normalizeResults(data);
        })
        .catch((err) => {
          console.error('Fallback search also failed:', err);
          return localFilter();
        });
    }

    return fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(function (response) {
        if (!response.ok) {
          console.error('Search API returned error status:', response.status);
          return fetchFallback();
        }
        return response.json();
      })
      .then(function (data) {
        var results = normalizeResults(data);
        console.log('Search returned', results.length, 'results');
        return results;
      })
      .catch(function (error) {
        console.error('Error in searchAis:', error);
        return fetchFallback();
      });
  };
  dataAccessorSelf.searchAiImages = function (query, offset = 0, limit = 120) {
    let params = {
      query: query,
      offset: offset,
      limit: limit,
    };

    var imageParams = new URLSearchParams(params);
    if (window.addAllowNSFWParam) {
      window.addAllowNSFWParam(imageParams);
    }

    return fetch(
      searchBaseUrl + '/api/search-aiimages?' + imageParams.toString(),
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
      .then(async function (response) {
        var text = await response.text();
        if (!response.ok) {
          throw new Error(
            'Image search failed ' +
              response.status +
              ': ' +
              text.slice(0, 180)
          );
        }
        try {
          return text ? JSON.parse(text) : [];
        } catch (e) {
          throw new Error('Image search returned invalid JSON: ' + text.slice(0, 180));
        }
      })
      .then(function (data) {
        if (Array.isArray(data)) {
          return data;
        }
        if (data && Array.isArray(data.results)) {
          return data.results;
        }
        if (data && Array.isArray(data.data)) {
          return data.data;
        }
        return [];
      })
      .catch(function (error) {
        console.error('Error searching AI images:', error);
        return [];
      });
  };

  dataAccessorSelf.getWidthHeight = function () {
    var aspect = dataAccessorSelf.getAspect();
    var width = 1024;
    var height = 1024;
    if (aspect === 'square') {
    }
    if (aspect === 'landscape') {
      width = 1152;
      height = 768;
    }
    if (aspect === 'portrait') {
      width = 768;
      height = 1152;
    }
    if (aspect === 'landscape43') {
      width = 1152;
      height = 864;
    }
    if (aspect === 'portrait43') {
      width = 864;
      height = 1152;
    }
    if (aspect === 'widescreen') {
      width = 1360;
      height = 768;
    }
    if (aspect === 'tall') {
      width = 768;
      height = 1360;
    }
    if (aspect === 'hdwidescreen') {
      width = 1920;
      height = 1080;
    }
    if (aspect === 'hdtall') {
      width = 1080;
      height = 1920;
    }
    return { aspect, width, height };
  };

  dataAccessorSelf.makeAIImage = function (prompt, name, width, height) {
    var sizeKey = dataAccessorSelf.getKeyForSDSize();

    if (typeof width === 'undefined' || typeof height === 'undefined') {
      var dims = dataAccessorSelf.getWidthHeight();
      width = dims.width;
      height = dims.height;
    }

    if (height == 1920) {
      height = 1360;
    }
    if (width == 1920) {
      width = 1360;
    }
    if (width == 1080) {
      width = 768;
    }
    if (height == 1080) {
      height = 768;
    }

    var falargs = {
      prompt: prompt,
      model_name: 'fal-ai/flux/schnell',
      image_size: sizeKey,
      num_inference_steps: 4,
      guidance_scale: 3.5,
      num_images: 1,
      enable_safety_checker: false,
    };

    return dataAccessorSelf.falFetch(falargs).then(async function (result) {
      var decoded = await result.json();
      var filefullURL = decoded.result.images[0].url;
      return {
        path: filefullURL,
      };
    });
  };

  dataAccessorSelf.makeAIStyleTransferImage = function (
    prompt,
    name,
    styleImgUrl
  ) {
    var sizeKey = dataAccessorSelf.getKeyForSDSize();

    var kontextArgs = {
      prompt: prompt,
      model_name: 'fal-ai/flux-pro/kontext',
      image_url: styleImgUrl,
    };

    var promises = [];

    promises.push(
      dataAccessorSelf
        .falFetch(kontextArgs)
        .then(async function (result) {
          var decoded = await result.json();
          return {
            path: decoded.result.images[0].url,
            model: 'kontext',
          };
        })
        .catch(function (err) {
          console.error('Kontext style transfer failed:', err);
          return null;
        })
    );

    return Promise.all(promises).then(function (results) {
      var validResults = results.filter(function (r) {
        return r !== null;
      });
      if (validResults.length === 0) {
        throw new Error('All style transfer methods failed');
      }

      return validResults[0];
    });
  };

  dataAccessorSelf.getAIByName = function (name, timeoutMs = 4000) {
    var friendlyName =
      window.RouteUtils && RouteUtils.normalizeCharacterSlugToName
        ? RouteUtils.normalizeCharacterSlugToName(name)
        : (name || '').replace(/-/g, ' ');

    function withTimeout(promise, ms) {
      return new Promise(function (resolve, reject) {
        var timer = setTimeout(function () {
          reject(new Error('Request timed out'));
        }, ms);
        promise
          .then(function (val) {
            clearTimeout(timer);
            resolve(val);
          })
          .catch(function (err) {
            clearTimeout(timer);
            reject(err);
          });
      });
    }

    function fetchOnce() {
      var controller =
        typeof AbortController !== 'undefined' ? new AbortController() : null;
      var signal = controller ? controller.signal : undefined;
      var fetchPromise = fetch(
        searchBaseUrl +
          '/api/get-ai-by-name?' +
          new URLSearchParams({
            name: name,
          }),
        {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          signal: signal,
        }
      );

      return withTimeout(fetchPromise, timeoutMs)
        .catch(function (err) {
          if (controller)
            try {
              controller.abort();
            } catch (e) {
              console.error('Error aborting controller:', e);
            }
          throw err;
        })
        .then(function (response) {
          if (!response.ok) {
            return response
              .json()
              .catch(function () {
                return {};
              })
              .then(function (errorData) {
                var error = new Error(
                  (errorData && (errorData.error || errorData.message)) ||
                    'HTTP Error: ' + response.status
                );
                error.status = response.status;
                throw error;
              });
          }
          return response.json();
        })
        .then(function (json) {
          if (
            json &&
            typeof json === 'object' &&
            json.success === true &&
            json.data
          ) {
            return json.data;
          }
          return json;
        });
    }

    function sleep(ms) {
      return new Promise(function (r) {
        setTimeout(r, ms);
      });
    }

    // Retry up to 2 times on failure with backoff
    return fetchOnce()
      .catch(function first(err) {
        if (err.status && err.status < 500) throw err;
        return sleep(500)
          .then(fetchOnce)
          .catch(function second(secondError) {
            if (secondError.status && secondError.status < 500) {
              throw secondError;
            }
            return sleep(1000).then(fetchOnce);
          });
      })
      .catch(function (error) {
        console.error('Error fetching AI character:', error);
        return {
          error: true,
          errorMessage: error.message || 'Error fetching character',
          name: friendlyName || name || 'Character unavailable',
          description: 'Character unavailable',
          greeting: '',
          avatar_file_name: '',
        };
      });
  };
  dataAccessorSelf.saveAICharacter = function (
    ainame,
    aidescription,
    aigreeting,
    newaiavatarurl,
    aipublic,
    newaibucketname
  ) {
    const aiCharacter = {
      name: ainame,
      description: aidescription,
      greeting: aigreeting,
      image_url: newaiavatarurl,
      newaibucketname: newaibucketname,
      visibility: aipublic,
      // Prefer userData.secret, fall back to cookie/localStorage helpers
      secret:
        (window.userData && (window.userData.secret || window.userData.api_key)) ||
        window.userSecret ||
        (typeof localStorage !== 'undefined'
          ? localStorage.getItem('userSecret')
          : '') ||
        (window.authSession && window.authSession.getUserSecret && window.authSession.getUserSecret()) ||
        '',
    };
    return fetch('/api/create-ai', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(aiCharacter),
    })
      .then(async (response) => {
        const responseJSON = await response.json().catch(() => null);
        if (!response.ok) {
          if (response.status === 401) {
            try {
              if (typeof window !== 'undefined' && window.showLoginDialog) {
                window.showLoginDialog();
              }
            } catch (e) {
              console.warn('[saveMessage] Failed to open login dialog:', e);
            }
          }
          throw new Error(
            (responseJSON && (responseJSON.error || responseJSON.message)) ||
              'Character creation failed'
          );
        }
        if (!responseJSON || responseJSON.success === false) {
          throw new Error(
            (responseJSON && (responseJSON.error || responseJSON.message)) ||
              'Character creation failed'
          );
        }
        return responseJSON;
      })
      .then((response_json) => {
        const createdAI =
          response_json && response_json.data
            ? response_json.data
            : response_json || {};
        window.fixtures.currentAI = {
          ...createdAI,
          name: createdAI.name || ainame,
          description: createdAI.description || aidescription,
          greeting: createdAI.greeting || aigreeting,
          avatar_file_name:
            createdAI.avatar_file_name || newaiavatarurl,
          is_user_created: true,
        };
        window.currentAI = window.fixtures.currentAI;
        window.currentName = window.currentAI.name;
        if (!dataAccessorSelf.aisByName) dataAccessorSelf.aisByName = {};
        dataAccessorSelf.aisByName[window.currentName] = window.fixtures.currentAI;
        if (createdAI.url_name) {
          dataAccessorSelf.aisByName[createdAI.url_name] = window.fixtures.currentAI;
        }
        const createdKey = String(createdAI.url_name || window.currentName).toLowerCase();
        const prependCreated = (items) => [window.currentAI].concat((items || []).filter((ai) => {
          const key = String(ai?.url_name || ai?.URLName || ai?.name || ai?.Name || '').toLowerCase();
          return key !== createdKey;
        }));
        dataAccessorSelf.userAIsData = prependCreated(dataAccessorSelf.userAIsData);
        dataAccessorSelf.topAIsData = prependCreated(dataAccessorSelf.topAIsData);
        dataAccessorSelf.topAIsUserLoaded = dataAccessorSelf.userAIsComplete === true;
        document.getElementById('autoCompleteUsersList')?.removeAttribute('data-owned-priority');

        if (window.currentAI) {
          window.fixtures.currentAI = window.currentAI;
        }

        return createdAI;
      })
      .catch((error) => {
        console.error('Error:', error);
        throw error;
      });
  };

  const extractAIArray = (value) => {
    if (Array.isArray(value)) return value;
    if (value && Array.isArray(value.data)) return value.data;
    return [];
  };

  dataAccessorSelf.userAIs = function (secret, force = false) {
    if (!force && dataAccessorSelf.userAIsData && dataAccessorSelf.userAIsComplete) return Promise.resolve(dataAccessorSelf.userAIsData);
    if (!force && dataAccessorSelf.userAIsRequest) return dataAccessorSelf.userAIsRequest;
    const user = typeof window !== 'undefined' ? window.userData || {} : {};
    const authenticated = Boolean(secret || user.secret || user.api_key || user.email || user.id || window.userSecret);
    if (!authenticated) return Promise.resolve(dataAccessorSelf.userAIsData || []);
    const request = fetch('/api/get-characters-for-user', {
      method: 'GET',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    })
      .then((response) => response.ok ? response.json().then((payload) => ({ ok: true, payload })) : { ok: false, payload: [] })
      .catch(() => ({ ok: false, payload: [] }));
    dataAccessorSelf.userAIsRequest = request.then((result) => {
      const seen = new Set();
      const merged = [];
      const add = (ai) => {
        const key = String(ai?.url_name || ai?.URLName || ai?.name || ai?.Name || '').toLowerCase();
        if (!key || seen.has(key)) return;
        seen.add(key);
        merged.push({ ...ai, is_user_created: true });
      };
      (dataAccessorSelf.userAIsData || []).forEach(add);
      extractAIArray(result.payload).forEach(add);
      dataAccessorSelf.userAIsData = merged;
      dataAccessorSelf.userAIsComplete = result.ok;
      return merged;
    }).finally(() => {
      dataAccessorSelf.userAIsRequest = null;
    });
    return dataAccessorSelf.userAIsRequest;
  };

  dataAccessorSelf.topAIs = function (secret) {
    const includeUserAIs = Boolean(secret || window.userData?.secret || window.userData?.api_key || window.userData?.email || window.userData?.id || window.userSecret);
    if (dataAccessorSelf.topAIsData && (!includeUserAIs || dataAccessorSelf.topAIsUserLoaded)) {
      return Promise.resolve(dataAccessorSelf.topAIsData);
    }

    const topUrl = secret ? `/api/top-ais?secret=${secret}` : '/api/top-ais';
    const searchUrl = '/api/search-ais?query=popular&limit=50';

    const safeJson = (res) => (res && res.ok ? res.json() : Promise.resolve([]));

    return Promise.allSettled([
      includeUserAIs ? dataAccessorSelf.userAIs(secret) : Promise.resolve([]),
      fetch(topUrl, { method: 'GET', headers: { 'Content-Type': 'application/json' } }).then(safeJson),
      fetch(searchUrl, { method: 'GET', headers: { 'Content-Type': 'application/json' } }).then(safeJson),
    ])
      .then((results) => {
        const userResult = results[0].status === 'fulfilled' ? results[0].value : [];
        const topResult = results[1].status === 'fulfilled' ? results[1].value : [];
        const searchResult = results[2].status === 'fulfilled' ? results[2].value : [];

        const userAIs = extractAIArray(userResult);
        const topAIs = extractAIArray(topResult);
        const searchAIs = extractAIArray(searchResult);

        const seen = new Set();
        const combined = [];
        const pushUnique = (ai) => {
          if (!ai) return;
          const name = (ai.name || ai.Name || '').trim();
          if (!name) return;
          const key = name.toLowerCase();
          if (seen.has(key)) return;
          seen.add(key);
          const isUserCreated = !!(ai.is_user_created || ai.user_created || ai.IsUserCreated);
          combined.push({ ...ai, is_user_created: isUserCreated });
        };

        userAIs.forEach((ai) => pushUnique({ ...ai, is_user_created: true }));
        topAIs.forEach((ai) => pushUnique(ai));
        searchAIs.forEach((ai) => pushUnique(ai));

        dataAccessorSelf.topAIsData = combined;
        dataAccessorSelf.topAIsUserLoaded = includeUserAIs && dataAccessorSelf.userAIsComplete === true;
        dataAccessorSelf.initialAIs = combined;

        if (!dataAccessorSelf.aisByName) {
          dataAccessorSelf.aisByName = {};
        }
        combined.forEach((ai) => {
          const name = ai && (ai.name || ai.Name);
          if (name) {
            dataAccessorSelf.aisByName[name] = ai;
          }
        });

        return combined;
      })
      .catch((error) => {
        console.error('Error loading top/search AIs:', error);
        return [];
      });
  };

  dataAccessorSelf.saveMessage = function (
    text,
    username,
    avatar_file_name,
    roomkey
  ) {
    if (window.fixtures?.room_name && (window.fixtures.room_is_private || new URLSearchParams(window.location.search).get('anon_chat') === '1')) return Promise.resolve();
    var attachments = [];
    var seenAttachmentUrls = new Set();

    function escapeAttachmentField(value) {
      if (!value) return '';
      return String(value).trim();
    }

    if (typeof sessionStorage !== 'undefined') {
      try {
        var stored = JSON.parse(sessionStorage.getItem('chatMedia') || '[]');
        if (Array.isArray(stored)) {
          stored.forEach(function (item) {
            if (!item || !item.uploadResult) return;
            var url = escapeAttachmentField(item.uploadResult.url || item.url);
            if (!url || !/^https?:\/\//i.test(url)) {
              return;
            }
            if (seenAttachmentUrls.has(url)) {
              return;
            }
            seenAttachmentUrls.add(url);

            var type =
              escapeAttachmentField(
                item.fileType ||
                  (item.uploadResult && item.uploadResult.type) ||
                  ''
              ) || '';
            var caption =
              escapeAttachmentField(item.caption) ||
              escapeAttachmentField(
                item.uploadResult && item.uploadResult.filename
              );
            var alt =
              escapeAttachmentField(item.alt) ||
              caption ||
              'Attachment';

            attachments.push({
              url: url,
              type: type,
              caption: caption,
              alt: alt,
            });
          });
        }
      } catch (err) {
        console.warn('[saveMessage] Failed parsing cached media attachments:', err);
      }
    }

    if (attachments.length > 6) {
      attachments = attachments.slice(0, 6);
    }

    var payload = {
      text: text,
      username: username,
      avatar_file_name: avatar_file_name,
      chat_room_id: roomkey,
    };
    if (attachments.length > 0) {
      payload.attachments = attachments;
    }

    return fetch('/api/save-message', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            try {
              if (typeof window !== 'undefined' && window.showSignupDialog) {
                window.showSignupDialog();
              }
            } catch (e) {
              console.warn('[saveMessage] Failed to open signup dialog:', e);
            }
          }
          throw new Error('Bad response from server');
        }
        return response.json();
      })
      .then((data) => {
        const liveEnabled =
          window.fixtures && window.fixtures.live_updates_enabled;
        if (roomkey && liveEnabled) {
          fetch(searchBaseUrl + '/api/live/publish', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              channel: roomkey,
              data: {
                text: text,
                username: username,
                avatar_file_name: avatar_file_name,
                attachments: attachments,
              },
            }),
          }).catch((err) => console.error('live publish error', err));
        }
        if (typeof sessionStorage !== 'undefined') {
          sessionStorage.removeItem('chatMedia');
        }
        return data;
      })
      .catch((error) => {
        console.error('Error:', error);

        return error;
      });
  };
  var ownedRooms = [];

  dataAccessorSelf.checkOwnsRoom = function (user, roomkey) {
    if (ownedRooms.indexOf(roomkey) !== -1) {
      return true;
    }

    return fetch('/api/check-owns-room', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        uid: user.uid,
        secret: user.secret,
        roomkey: roomkey,
      }),
    })
      .then((response) => {
        if (response.status !== 200) {
          throw new Error('Bad response from server');
        }
        return response.json();
      })
      .then((response_json) => {
        if (response_json.success) {
          ownedRooms.push(roomkey);
        }
        return response_json.success;
      })
      .catch((error) => {
        console.error('Error:', error);
        return false;
      });
  };

  dataAccessorSelf.getAspect = function () {
    let squareAspect = $('#squareaspect').is(':checked');
    if (squareAspect) {
      return 'square';
    }

    let landscapeAspect = $('#landscapeaspect').is(':checked');
    if (landscapeAspect) {
      return 'landscape';
    }
    let portraitAspect = $('#portraitaspect').is(':checked');
    if (portraitAspect) {
      return 'portrait';
    }
    let landscape43aspect = $('#landscape43aspect').is(':checked');
    if (landscape43aspect) {
      return 'landscape43';
    }
    let portrait43aspect = $('#portrait43aspect').is(':checked');
    if (portrait43aspect) {
      return 'portrait43';
    }
    let widescreenaspect = $('#widescreenaspect').is(':checked');
    if (widescreenaspect) {
      return 'widescreen';
    }
    let tallAspect = $('#tallaspect').is(':checked');
    if (tallAspect) {
      return 'tall';
    }
    let hdwidescreenAspect = $('#hdwidescreenaspect').is(':checked');
    if (hdwidescreenAspect) {
      return 'hdwidescreen';
    }
    let hdtallAspect = $('#hdtallaspect').is(':checked');
    if (hdtallAspect) {
      return 'hdtall';
    }

    return 'square';
  };
  dataAccessorSelf.getKeyForSDSize = function () {
    var aspectMap = {
      square: 'square_hd',
      landscape: 'landscape_3_2',
      portrait: 'portrait_2_3',
      landscape43: 'landscape_4_3',
      portrait43: 'portrait_4_3',
      widescreen: 'landscape_16_9',
      tall: 'portrait_16_9',
      hdwidescreen: 'landscape_16_9',
      hdtall: 'portrait_16_9',
    };
    var aspect = dataAccessorSelf.getAspect();
    return aspectMap[aspect];
  };

  function isUsableFalSecret(secret) {
    secret = String(secret || '').trim();
    return !!(
      secret &&
      secret !== 'anonymous' &&
      secret !== 'secret' &&
      secret !== 'YOUR_API_KEY' &&
      secret !== 'null' &&
      secret !== 'undefined'
    );
  }

  function getFalSecret() {
    if (
      window.netwrckGetAuthSecret &&
      isUsableFalSecret(window.netwrckGetAuthSecret())
    ) {
      return String(window.netwrckGetAuthSecret()).trim();
    }
    var candidates = [
      window.userData && (window.userData.secret || window.userData.api_key),
      window.userSecret,
      localStorage.getItem('userSecret'),
      sessionStorage.getItem('user_secret'),
    ];
    for (var i = 0; i < candidates.length; i++) {
      if (isUsableFalSecret(candidates[i])) return String(candidates[i]).trim();
    }
    return '';
  }

  dataAccessorSelf.falFetch = function (data) {
    return Promise.resolve(window.userDataReady || window.userData)
      .catch(function () {
        return window.userData;
      })
      .then(function () {
        var secret = getFalSecret();
        var payload = Object.assign({}, data || {});
        if (secret && !payload.api_key && !payload.secret) {
          payload.api_key = secret;
        }
        var headers = { 'Content-Type': 'application/json' };
        if (secret) {
          headers['X-API-Key'] = secret;
          headers['Authorization'] = 'Bearer ' + secret;
        }
        return fetch(baseProxyUrl + '/fal', {
          method: 'POST',
          headers: headers,
          credentials: 'include',
          body: JSON.stringify(payload),
          timeout: 300000,
        }).then(async function (response) {
          if (response.status === 401) {
            if (typeof window.showLoginDialog === 'function') {
              window.showLoginDialog(null, window.location.pathname);
            }
            throw new Error('Authentication required');
          }
          if (response.status === 402) {
            if (typeof window.showSubscribeDialog === 'function') {
              window.showSubscribeDialog();
            }
            throw new Error('Subscription required');
          }
          if (!response.ok) {
            var body = '';
            try {
              body = await response.text();
            } catch (e) {
              body = '';
            }
            throw new Error(
              'FAL request failed ' +
                response.status +
                (body ? ': ' + body.slice(0, 180) : '')
            );
          }
          return response;
        });
      });
  };

  dataAccessorSelf.voices = {
    localVoices: [],
    publicVoices: [],

    loadLocalVoices() {
      return new Promise((resolve) => {
        try {
          const saved = localStorage.getItem('localVoices');
          if (saved) {
            this.localVoices = JSON.parse(saved);
          }
          resolve(this.localVoices);
        } catch (e) {
          console.error('Error loading local voices:', e);
          this.localVoices = [];
          resolve([]);
        }
      });
    },

    saveLocalVoices() {
      return new Promise((resolve, reject) => {
        try {
          localStorage.setItem('localVoices', JSON.stringify(this.localVoices));
          resolve(this.localVoices);
        } catch (e) {
          console.error('Error saving local voices:', e);
          reject(e);
        }
      });
    },

    async getAllVoices() {
      const [publicVoices, localVoices] = await Promise.all([
        this.fetchPublicVoices(),
        this.loadLocalVoices(),
      ]);
      return [...localVoices, ...publicVoices];
    },

    async fetchPublicVoices() {
      try {
        const response = await fetch('/api/get-public-voices');
        if (!response.ok) throw new Error('Failed to fetch public voices');
        this.publicVoices = await response.json();
        return this.publicVoices;
      } catch (e) {
        console.error('Error fetching public voices:', e);
        this.publicVoices = [];
        return [];
      }
    },

    async createVoice(voiceData) {
      const localVoice = { ...voiceData, id: Date.now() };
      this.localVoices.push(localVoice);
      await this.saveLocalVoices();

      if (voiceData.visibility === 'PUBLIC') {
        try {
          const response = await fetch('/api/create-voice', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(voiceData),
          });

          if (!response.ok) throw new Error('Failed to create voice on server');

          const serverVoice = await response.json();

          const index = this.localVoices.findIndex(
            (v) => v.id === localVoice.id
          );
          if (index !== -1) {
            this.localVoices[index] = {
              ...serverVoice,
              localId: localVoice.id,
            };
            await this.saveLocalVoices();
          }
          return serverVoice;
        } catch (e) {
          console.error('Error creating voice on server:', e);

          return localVoice;
        }
      }

      return localVoice;
    },

    async deleteVoice(voiceId) {
      this.localVoices = this.localVoices.filter((v) => v.id !== voiceId);
      await this.saveLocalVoices();

      try {
        const response = await fetch(`/api/delete-voice/${voiceId}`, {
          method: 'DELETE',
        });
        if (!response.ok) throw new Error('Failed to delete voice from server');
        return true;
      } catch (e) {
        console.error('Error deleting voice from server:', e);
        return false;
      }
    },

    async updateVoice(voiceId, updates) {
      const index = this.localVoices.findIndex((v) => v.id === voiceId);
      if (index !== -1) {
        this.localVoices[index] = { ...this.localVoices[index], ...updates };
        await this.saveLocalVoices();
      }

      if (updates.visibility === 'PUBLIC') {
        try {
          const response = await fetch(`/api/update-voice/${voiceId}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(updates),
          });

          if (!response.ok) throw new Error('Failed to update voice on server');
          const serverVoice = await response.json();
          return serverVoice;
        } catch (e) {
          console.error('Error updating voice on server:', e);
          return this.localVoices[index];
        }
      }

      return this.localVoices[index];
    },
  };

  dataAccessorSelf.voices.loadLocalVoices().catch(console.error);

  // Ensure global access for both script-tag and bundled builds
  if (typeof window !== 'undefined') {
    try {
      var existingAccessor = window.dataAccessor || {};
      if (existingAccessor.aisByName && !dataAccessorSelf.aisByName) {
        dataAccessorSelf.aisByName = existingAccessor.aisByName;
      }
      window.dataAccessor = dataAccessorSelf;
    } catch (e) {
      // no-op
    }

    // Invalidate cached data on auth changes so views refresh correctly
    try {
      window.addEventListener('authStateChanged', function () {
        dataAccessorSelf.invalidateRoomsCache();
      });
    } catch (e) {
      // no-op
    }
  }

  return dataAccessorSelf;
})();
